import React, { useState, useEffect } from 'react';
import { db } from '../../utils/firebase'; 
import { collection, getDocs, doc, setDoc, query, updateDoc, getDoc, writeBatch } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import { FiCheck, FiX, FiInbox, FiRefreshCw, FiSmartphone, FiMessageSquare, FiTrash2 } from 'react-icons/fi';
import MigrationTool from '../mig/mig';

const CONFIG = {
    EXPIRE_DAYS: 5,
    STATUS_ACTIVE: "active",
    STATUS_REJECTED: "rejected",
    STATUS_PENDING: "pending",
    STATUS_APPROVED: "approved"
};

const AppScreen = () => {
    const [requests, setRequests] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [processingId, setProcessingId] = useState(null); 
    const [activeTab, setActiveTab] = useState(CONFIG.STATUS_PENDING); // Ямар төлөвтэйг харах Tab
    
    const auth = getAuth();

    const fetchRequests = async () => {
        if (!auth.currentUser?.displayName) return;
        setIsLoading(true);
        try {
            const reqRef = collection(db, 'parkings', auth.currentUser.displayName, 'requests');
            const q = query(reqRef); 
            
            const snapshot = await getDocs(q);
            const data = snapshot.docs.map(doc => {
                const reqData = doc.data();
                return { 
                    id: doc.id, 
                    // Хэрэв status байхгүй бол pending гэж үзнэ
                    status: reqData.status || CONFIG.STATUS_PENDING, 
                    ...reqData 
                };
            });
            
            // Бух өгөгдлөө хадгална
            setRequests(data);
        } catch (error) {
            console.error("Хүсэлтүүдийг татахад алдаа гарлаа:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.currentUser]);

    const handleAction = async (id, actionType) => {
        if (!auth.currentUser?.displayName || processingId) return;
        
        const isApprove = actionType === 'approve';
        const confirmMsg = isApprove 
            ? 'Энэ машиныг зөвшөөрч системд бүртгэх үү?' 
            : 'Энэ хүсэлтээс татгалзах уу?';
            
        if (!window.confirm(confirmMsg)) return;

        setProcessingId(id); 

        try {
            const requestRef = doc(db, 'parkings', auth.currentUser.displayName, 'requests', id);
            const targetRequest = requests.find(req => req.id === id);

            if (!targetRequest) {
                throw new Error("Хүсэлтийн мэдээлэл олдсонгүй.");
            }

            if (isApprove) {
    const carRef = doc(db, 'parkings', auth.currentUser.displayName, 'registeredCars', id);
    const now = new Date();
    let newExpireDate = new Date(now);

    // 1. Тухайн машин өмнө нь бүртгэгдсэн эсэхийг Firestore-оос шалгах
    const carSnap = await getDoc(carRef);

    if (carSnap.exists()) {
        const existingData = carSnap.data();
        
        if (existingData.expireDate) {
            const currentExpireDate = existingData.expireDate.toDate 
                ? existingData.expireDate.toDate() 
                : new Date(existingData.expireDate);

            // 2. Хэрэв өмнөх хугацаа нь дуусаагүй (өнөөдрөөс хойш) байвал
            if (currentExpireDate > now) {
                // Өмнөх хугацаан дээр 5 хоногийг нэмэх
                newExpireDate = new Date(currentExpireDate);
                newExpireDate.setDate(newExpireDate.getDate() + CONFIG.EXPIRE_DAYS);
            } else {
                // Хугацаа дууссан байвал өнөөдрөөс 5 хоног тооцох
                newExpireDate.setDate(now.getDate() + CONFIG.EXPIRE_DAYS);
            }
        } else {
            newExpireDate.setDate(now.getDate() + CONFIG.EXPIRE_DAYS);
        }
        } else {
            // Анх удаа бүртгүүлж байгаа бол өнөөдрөөс 5 хоног тооцох
            newExpireDate.setDate(now.getDate() + CONFIG.EXPIRE_DAYS);
        }

        // 3. Өгөгдлөө бэлтгэх (Хоосон утгаар хуучин өгөгдлийг даруулахгүй байх логик)
        const updateData = {
            isVip: true,
            lastUpdated: now,
            isBlocked: false,
            status: CONFIG.STATUS_ACTIVE,
            expireDate: newExpireDate, // Шинээр тооцсон хугацаа
            updatedAt: now,
            uid:targetRequest.uid || id
        };

        // Хэрэглэгч хүсэлтдээ эдгээр мэдээллийг оруулсан байвал л шинэчилнэ
        if (targetRequest.plate) updateData.plate = targetRequest.plate;
        if (targetRequest.phone) updateData.phone = targetRequest.phone;
        if (targetRequest.userName) updateData.userName = targetRequest.userName;
        if (targetRequest.address) updateData.address = targetRequest.address;
        if (targetRequest.apartment) updateData.apartment = targetRequest.apartment;
        if (targetRequest.description) updateData.description = targetRequest.description;

        // Өгөгдлийг хадгалах / шинэчлэх
        await setDoc(carRef, updateData, { merge: true });

        // Хүсэлтийн төлөвийг 'approved' болгож шинэчлэх
        await updateDoc(requestRef, {
            status: CONFIG.STATUS_APPROVED,
            updatedAt: now
        });
    } else {
                    await updateDoc(requestRef, {
                        status: CONFIG.STATUS_REJECTED,
                        updatedAt: new Date()
                    });
                }

            // Local state-ээ шинэчлэх (Дахин татах шаардлагагүйгээр UI өөрчлөгдөнө)
            setRequests(prev => prev.map(req => 
                req.id === id ? { ...req, status: isApprove ? CONFIG.STATUS_APPROVED : CONFIG.STATUS_REJECTED } : req
            ));
            
        } catch (error) {
            console.error("Үйлдэл хийхэд алдаа гарлаа:", error);
            alert("Алдаа гарлаа, дахин оролдоно уу.");
        } finally {
            setProcessingId(null); 
        }
    };

    const handleDelete = async (request) => {
        if (!auth.currentUser?.displayName || processingId) return;

        // Зөвхөн зөвшөөрсөн болон татгалзсан хүсэлтийг устгана
        const canDelete = [CONFIG.STATUS_APPROVED, CONFIG.STATUS_REJECTED].includes(request.status);
        if (!canDelete) {
            alert('Шинэ хүсэлтийг шууд устгах боломжгүй. Эхлээд зөвшөөрөх эсвэл татгалзана уу.');
            return;
        }

        const statusText = request.status === CONFIG.STATUS_APPROVED
            ? 'зөвшөөрсөн'
            : 'татгалзсан';

        const confirmMsg =
            `${request.plate || 'Дугааргүй'} дугаартай ${statusText} хүсэлтийг бүрмөсөн устгах уу?` +
            (request.status === CONFIG.STATUS_APPROVED
                ? '\n\nАнхаар: Хүсэлтийн түүх болон бүртгэлтэй машины мэдээлэл хамт устна.'
                : '\n\nТатгалзсан хүсэлтийн мэдээлэл устна.');

        if (!window.confirm(confirmMsg)) return;

        setProcessingId(request.id);

        try {
            const parkingId = auth.currentUser.displayName;
            const requestRef = doc(
                db,
                'parkings',
                parkingId,
                'requests',
                request.id
            );

            // Batch ашигласнаар хүсэлт болон машины бүртгэлийг нэг үйлдлээр устгана.
            const batch = writeBatch(db);
            batch.delete(requestRef);

            if (request.status === CONFIG.STATUS_APPROVED) {
                const carRef = doc(
                    db,
                    'parkings',
                    parkingId,
                    'registeredCars',
                    request.id
                );
                batch.delete(carRef);
            }

            await batch.commit();

            // Firestore-оос устгасны дараа дэлгэцээс шууд хасна
            setRequests(prev => prev.filter(item => item.id !== request.id));
        } catch (error) {
            console.error('Хүсэлт устгахад алдаа гарлаа:', error);
            alert('Хүсэлтийг устгаж чадсангүй. Дахин оролдоно уу.');
        } finally {
            setProcessingId(null);
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return { date: '-', time: '' };
        const d = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        return {
            date: d.toLocaleDateString('mn-MN'),
            time: d.toLocaleTimeString('mn-MN', { hour: '2-digit', minute: '2-digit' })
        };
    };

    // Одоо идэвхтэй байгаа Tab-д тохирох датаг шүүх
    const filteredRequests = requests.filter(req => req.status === activeTab);

    return (
        <div className="tw-bg-slate-50 tw-min-h-screen tw-p-3 sm:tw-p-6 lg:tw-p-8 tw-font-sans tw-text-slate-800 tw-max-w-[100vw] tw-overflow-x-hidden">
            
            <header className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-mb-6 sm:tw-mb-8 tw-gap-4">
                <div>
                    <h2 className="tw-text-xl sm:tw-text-2xl lg:tw-text-3xl tw-font-bold tw-text-slate-900 tw-tracking-tight tw-flex tw-items-center tw-gap-2.5 tw-m-0">
                        <div className="tw-w-8 sm:tw-w-10 tw-h-8 sm:tw-h-10 tw-rounded-xl tw-bg-blue-50 tw-flex tw-items-center tw-justify-center tw-text-blue-600 tw-flex-shrink-0">
                            <FiSmartphone className="tw-w-4 tw-h-4 sm:tw-w-5 sm:tw-h-5" />
                        </div>
                        Апп Хүсэлтүүд
                    </h2>
                    <p className="tw-text-xs sm:tw-text-sm tw-text-slate-500 tw-mt-1 sm:tw-mt-2 tw-mb-0">Iparking аппликейшнээс ирсэн хэрэглэгчдийн хүсэлтүүд.</p>
                </div>
   
                
                <button 
                    onClick={fetchRequests}
                    disabled={isLoading}
                    className="tw-flex tw-items-center tw-justify-center tw-w-full sm:tw-w-auto tw-gap-2 tw-bg-white tw-border tw-border-slate-200 tw-text-slate-700 tw-px-4 sm:tw-px-5 tw-py-2.5 tw-rounded-xl tw-font-bold tw-text-xs sm:tw-text-sm tw-shadow-sm hover:tw-bg-slate-50 hover:tw-border-slate-300 tw-transition-all disabled:tw-opacity-60 disabled:tw-cursor-not-allowed active:tw-scale-95"
                >
                    <FiRefreshCw className={isLoading ? "tw-animate-spin tw-text-blue-500" : "tw-text-slate-400"} size={16} />
                    {isLoading ? 'Шинэчилж байна...' : 'Шинэчлэх'}
                </button>
            </header>

            {/* Ангилал (Tabs) */}
            <div className="tw-flex tw-gap-2 tw-mb-4 sm:tw-mb-6 tw-overflow-x-auto tw-pb-2">
                <button 
                    onClick={() => setActiveTab(CONFIG.STATUS_PENDING)}
                    className={`tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-bold tw-transition-colors tw-whitespace-nowrap ${activeTab === CONFIG.STATUS_PENDING ? 'tw-bg-blue-600 tw-text-white tw-shadow-sm' : 'tw-bg-white tw-border tw-border-slate-200 tw-text-slate-600 hover:tw-bg-slate-50'}`}
                >
                    Шинэ хүсэлт ({requests.filter(r => r.status === CONFIG.STATUS_PENDING).length})
                </button>
                <button 
                    onClick={() => setActiveTab(CONFIG.STATUS_APPROVED)}
                    className={`tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-bold tw-transition-colors tw-whitespace-nowrap ${activeTab === CONFIG.STATUS_APPROVED ? 'tw-bg-emerald-600 tw-text-white tw-shadow-sm' : 'tw-bg-white tw-border tw-border-slate-200 tw-text-slate-600 hover:tw-bg-slate-50'}`}
                >
                    Зөвшөөрсөн ({requests.filter(r => r.status === CONFIG.STATUS_APPROVED).length})
                </button>
                <button 
                    onClick={() => setActiveTab(CONFIG.STATUS_REJECTED)}
                    className={`tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-bold tw-transition-colors tw-whitespace-nowrap ${activeTab === CONFIG.STATUS_REJECTED ? 'tw-bg-rose-600 tw-text-white tw-shadow-sm' : 'tw-bg-white tw-border tw-border-slate-200 tw-text-slate-600 hover:tw-bg-slate-50'}`}
                >
                    Татгалзсан ({requests.filter(r => r.status === CONFIG.STATUS_REJECTED).length})
                </button>
            </div>

            <div className="tw-bg-white tw-shadow-sm tw-border tw-border-slate-200 tw-rounded-2xl tw-w-full tw-overflow-hidden tw-animate-in tw-fade-in tw-duration-300">
                {isLoading ? (
                    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-20 sm:tw-py-32">
                        <div className="tw-w-8 sm:tw-w-10 tw-h-8 sm:tw-h-10 tw-border-4 tw-border-blue-100 tw-border-t-blue-600 tw-rounded-full tw-animate-spin"></div>
                        <p className="tw-mt-4 tw-text-xs sm:tw-text-sm tw-font-bold tw-text-slate-500">Уншиж байна...</p>
                    </div>
                ) : filteredRequests.length === 0 ? (
                    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 sm:tw-py-24 tw-text-slate-400 tw-animate-in tw-fade-in">
                        <div className="tw-w-16 sm:tw-w-20 tw-h-16 sm:tw-h-20 tw-bg-slate-50 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4 sm:tw-mb-5 tw-text-slate-300">
                            <FiInbox className="tw-w-8 tw-h-8 sm:tw-w-10 sm:tw-h-10" />
                        </div>
                        <h3 className="tw-text-base sm:tw-text-lg tw-font-bold tw-text-slate-700 tw-mb-1">Мэдээлэл алга байна</h3>
                        <p className="tw-text-xs sm:tw-text-sm tw-text-slate-500 tw-text-center tw-px-4">Энэ хэсэгт харуулах хүсэлт одоогоор байхгүй байна.</p>
                    </div>
                ) : (
                    <div className="tw-overflow-x-auto tw-w-full tw-block">
                        <table className="tw-w-full tw-text-left tw-border-collapse tw-min-w-[800px] md:tw-min-w-[900px] tw-animate-in tw-fade-in">
                            <thead className="tw-bg-slate-50 tw-border-b tw-border-slate-200">
                                <tr>
                                    <th className="tw-px-4 sm:tw-px-6 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Хэрэглэгч</th>
                                    <th className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Улсын дугаар</th>
                                    <th className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Хаяг / Байр</th>
                                    <th className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Тоот</th>
                                    <th className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Тайлбар</th>
                                    <th className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Огноо</th>
                                    <th className="tw-px-4 sm:tw-px-6 tw-py-3 sm:tw-py-4 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider tw-text-right">Төлөв / Үйлдэл</th>
                                </tr>
                            </thead>
                            <tbody className="tw-divide-y tw-divide-slate-100">
                                {filteredRequests.map((req) => {
                                    const { date, time } = formatDate(req.updatedAt || req.createdAt);
                                    const initial = req.userName ? req.userName.charAt(0).toUpperCase() : 'U';
                                    const isThisRowProcessing = processingId === req.id;

                                    return (
                                        <tr key={req.id} className="hover:tw-bg-slate-50/80 tw-transition-colors">
                                            <td className="tw-px-4 sm:tw-px-6 tw-py-3 sm:tw-py-4">
                                                <div className="tw-flex tw-items-center tw-gap-2 sm:tw-gap-3">
                                                    <div className="tw-w-8 sm:tw-w-10 tw-h-8 sm:tw-h-10 tw-rounded-full tw-bg-indigo-100 tw-text-indigo-700 tw-font-bold tw-text-base sm:tw-text-lg tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                                                        {initial}
                                                    </div>
                                                    <div>
                                                        <div className="tw-text-xs sm:tw-text-sm tw-font-bold tw-text-slate-900">{req.userName || 'Нэргүй хэрэглэгч'}</div>
                                                        <div className="tw-text-[10px] sm:tw-text-xs tw-text-slate-500">{req.phone || 'Утас байхгүй'}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4">
                                                <span className="tw-inline-block tw-px-2 sm:tw-px-2.5 tw-py-1 tw-bg-slate-100 tw-border tw-border-slate-200 tw-rounded-md tw-text-xs sm:tw-text-sm tw-font-bold tw-text-slate-800 tw-tracking-wider">
                                                    {req.plate || '-----'}
                                                </span>
                                            </td>
                                            <td className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-xs sm:tw-text-sm tw-font-medium tw-text-slate-600">
                                                {req.address || '-----'}
                                            </td>
                                            <td className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4 tw-text-xs sm:tw-text-sm tw-font-bold tw-text-slate-900">
                                                {req.apartment || '-----'}
                                            </td>
                                            <td className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4">
                                                {req.description ? (
                                                    <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs sm:tw-text-sm tw-text-slate-600 tw-max-w-[120px] sm:tw-max-w-[150px] tw-truncate" title={req.description}>
                                                        <FiMessageSquare className="tw-text-slate-400 tw-flex-shrink-0" />
                                                        <span className="tw-truncate">{req.description}</span>
                                                    </div>
                                                ) : (
                                                    <span className="tw-text-slate-400">-</span>
                                                )}
                                            </td>
                                            <td className="tw-px-3 sm:tw-px-4 tw-py-3 sm:tw-py-4">
                                                <div className="tw-flex tw-flex-col">
                                                    <span className="tw-text-xs sm:tw-text-sm tw-font-bold tw-text-slate-700">{date}</span>
                                                    <span className="tw-text-[10px] sm:tw-text-xs tw-text-slate-500">{time}</span>
                                                </div>
                                            </td>
                                            <td className="tw-px-4 sm:tw-px-6 tw-py-3 sm:tw-py-4 tw-text-right">
                                                {/* Төлөвөөс хамаарч Батлах/Татгалзах товч ЭСВЭЛ утга (Badge) харуулна */}
                                                {req.status === CONFIG.STATUS_PENDING ? (
                                                    <div className="tw-flex tw-items-center tw-justify-end tw-gap-1.5 sm:tw-gap-2">
                                                        <button 
                                                            onClick={() => handleAction(req.id, 'reject')}
                                                            disabled={processingId !== null}
                                                            title="Татгалзах"
                                                            className={`tw-flex tw-items-center tw-gap-1.5 tw-px-2.5 sm:tw-px-3 tw-py-1.5 sm:tw-py-2 tw-rounded-lg tw-bg-white tw-border tw-border-slate-200 tw-text-rose-600 tw-text-[10px] sm:tw-text-xs tw-font-bold tw-transition-colors ${processingId !== null ? 'tw-opacity-50 tw-cursor-not-allowed' : 'hover:tw-bg-rose-50 hover:tw-border-rose-200'}`}
                                                        >
                                                            {isThisRowProcessing ? <FiRefreshCw className="tw-animate-spin" size={14}/> : <FiX size={14} />} 
                                                            <span className="tw-hidden xl:tw-inline">Татгалзах</span>
                                                        </button>
                                                        <button 
                                                            onClick={() => handleAction(req.id, 'approve')}
                                                            disabled={processingId !== null}
                                                            title="Зөвшөөрөх"
                                                            className={`tw-flex tw-items-center tw-gap-1.5 tw-px-2.5 sm:tw-px-3 tw-py-1.5 sm:tw-py-2 tw-rounded-lg tw-text-white tw-text-[10px] sm:tw-text-xs tw-font-bold tw-transition-all ${processingId !== null ? 'tw-bg-blue-400 tw-cursor-not-allowed' : 'tw-bg-blue-600 hover:tw-bg-blue-700 tw-shadow-sm hover:tw-shadow'}`}
                                                        >
                                                            {isThisRowProcessing ? <FiRefreshCw className="tw-animate-spin" size={14}/> : <FiCheck size={14} />} 
                                                            <span className="tw-hidden xl:tw-inline">Зөвшөөрөх</span>
                                                        </button>
                                                    </div>
                                                ) : req.status === CONFIG.STATUS_APPROVED ? (
                                                    <div className="tw-flex tw-items-center tw-justify-end tw-gap-2">
                                                        <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-bg-emerald-50 tw-text-emerald-700 tw-border tw-border-emerald-200 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-[10px] sm:tw-text-xs tw-font-bold">
                                                            <FiCheck size={14} /> Зөвшөөрсөн
                                                        </span>
                                                        <button
                                                            onClick={() => handleDelete(req)}
                                                            disabled={processingId !== null}
                                                            title="Хүсэлтийг устгах"
                                                            className={`tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-lg tw-border tw-text-rose-600 tw-transition-colors ${processingId !== null ? 'tw-opacity-50 tw-cursor-not-allowed tw-border-slate-200' : 'tw-border-rose-200 hover:tw-bg-rose-50 hover:tw-border-rose-300'}`}
                                                        >
                                                            {isThisRowProcessing
                                                                ? <FiRefreshCw className="tw-animate-spin" size={14} />
                                                                : <FiTrash2 size={14} />}
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="tw-flex tw-items-center tw-justify-end tw-gap-2">
                                                        <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-bg-rose-50 tw-text-rose-700 tw-border tw-border-rose-200 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-[10px] sm:tw-text-xs tw-font-bold">
                                                            <FiX size={14} /> Татгалзсан
                                                        </span>
                                                        <button
                                                            onClick={() => handleDelete(req)}
                                                            disabled={processingId !== null}
                                                            title="Хүсэлтийг устгах"
                                                            className={`tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-lg tw-border tw-text-rose-600 tw-transition-colors ${processingId !== null ? 'tw-opacity-50 tw-cursor-not-allowed tw-border-slate-200' : 'tw-border-rose-200 hover:tw-bg-rose-50 hover:tw-border-rose-300'}`}
                                                        >
                                                            {isThisRowProcessing
                                                                ? <FiRefreshCw className="tw-animate-spin" size={14} />
                                                                : <FiTrash2 size={14} />}
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AppScreen;